module.exports = __webpack_public_path__ + "img/1_mother.1996f1ca.jpg";